import { useEffect, useState } from 'react'
import dayjs from 'dayjs'

import { DATE_FORMAT } from 'constants/locale'

const useDatePicker = (fromDate, toDate) => {
  const [fromDateSelected, setFromDateSelected] = useState(fromDate)
  const [toDateSelected, setToDateSelected] = useState(toDate)
  const [disableSubmit, setDisableSubmit] = useState(true)

  useEffect(() => {
    setFromDateSelected(fromDate)
  }, [fromDate, setFromDateSelected])

  useEffect(() => {
    setToDateSelected(toDate)
  }, [toDate, setToDateSelected])

  useEffect(() => {
    const isSameFromDates = fromDateSelected === fromDate
    const isSameToDates = toDateSelected === toDate
    const isDateUnselected = !(fromDateSelected && toDateSelected)
    const isDateUnchanged = isSameFromDates && isSameToDates
    const disableSubmit = isDateUnchanged || isDateUnselected

    setDisableSubmit(disableSubmit)
  }, [fromDateSelected, toDateSelected, fromDate, toDate, setDisableSubmit])

  const onHandleFromDateSelectedChange = date => setFromDateSelected(dayjs(date).format(DATE_FORMAT))
  const onHandleToDateSelectedChange = date => setToDateSelected(dayjs(date).format(DATE_FORMAT))

  return {
    fromDateSelected,
    onHandleFromDateSelectedChange,
    toDateSelected,
    onHandleToDateSelectedChange,
    disableSubmit
  }
}

export default useDatePicker
